<script lang="ts">
import i3pSubComponent from '@nuxtDatakodeUtils/components/i3p/I3pSubComponent.vue'
// import EditButtonsBottomContent from '@nuxtDatakodeUtils/components/i3p/panels/editButtonsBottom/Content.vue'

import EditButtonsBottomContent from '@nuxtDatakodeUtils/components/i3p/panels/editButtonsBottom/Content.vue'
import { BaseRoutesEnum } from '~/enum/BaseRoutes.enum'

export default {
    name: 'TopButtons',
    components: { EditButtonsBottomContent },
    extends: i3pSubComponent,
    props: {},
    // component: { EditButtonsBottomContent },
    data() {
        return {
            modelPermissionName: null,
        }
    },
    computed: {
        BaseRoutesEnum() {
            return BaseRoutesEnum
        },
        model() {
            return this.i3pService.getModel()
        },
        responsiveClass() {
            return this.$vuetify.display.mdAndDown ? 'mb-2' : ''
        },
    },
    mounted() {
        this.modelPermissionName = this.i3pService.getModel().permissionName
    },
    methods: {
        async createEntity() {
            await this.i3pService.createEntity()
            this.i3pService.setEditMode(true)
        },
    },
}
</script>

<template>
    <div v-if="i3pService.editMode">
        <EditButtonsBottomContent :i3p-service />
    </div>
    <div v-else>
        <template v-if="baseUrl === BaseRoutesEnum.commandes">
            <v-btn
                v-if="$permissionCheck(`${modelPermissionName}_store`)" class="mr-2" :class="responsiveClass" variant="flat" prepend-icon="mdi-plus" size="small" color="primary"
                :loading="i3pService?.isSaving"
                @click="createEntity"
            >
                Ajouter une commande
            </v-btn>
        </template>
    </div>
</template>
